import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';

const HolidayModal = ({ holiday, onClose, onSave, onDelete, saving, deleting }) => {
  const [person, setPerson] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (holiday) {
      setPerson(holiday.person || '');
      setStartDate(format(new Date(holiday.startDate), 'yyyy-MM-dd'));
      setEndDate(format(new Date(holiday.endDate), 'yyyy-MM-dd'));
      setError('');
    }
  }, [holiday]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError('');

    if (!person || !startDate || !endDate) {
      setError('Täytä henkilön nimi sekä loman alku- ja loppupäivä.');
      return;
    }

    onSave({ person, startDate, endDate });
  };

  return (
    <div className="holiday-modal__backdrop" role="dialog" aria-modal="true">
      <div className="holiday-modal">
        <div className="holiday-modal__header">
          <div>
            <p className="eyebrow">Muokkaa lomaa</p>
            <h2>{holiday?.person}</h2>
          </div>
        </div>

        <form className="holiday-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label htmlFor="modal-person">Henkilö</label>
            <input
              id="modal-person"
              value={person}
              onChange={(e) => setPerson(e.target.value)}
              placeholder="Etunimi Sukunimi"
            />
          </div>
          <div className="form-grid">
            <div className="form-row">
              <label htmlFor="modal-start">Alkaa</label>
              <input
                id="modal-start"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="form-row">
              <label htmlFor="modal-end">Päättyy</label>
              <input
                id="modal-end"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          {error && <p className="form-message error">{error}</p>}

          <div className="holiday-modal__actions">
            <button
              type="button"
              className="ghost-button danger"
              onClick={() => onDelete(holiday._id)}
              disabled={deleting}
            >
              {deleting ? 'Poistetaan...' : 'Poista loma'}
            </button>
            <div className="holiday-modal__actions-right">
              <button type="button" className="ghost-button" onClick={onClose}>
                Peruuta
              </button>
              <button type="submit" className="holiday-primary-button" disabled={saving}>
                {saving ? 'Tallennetaan...' : 'Tallenna muutokset'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HolidayModal;
